/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Component, Input, EventEmitter, Output, TemplateRef } from '@angular/core';
import { Theme, Size } from 'app/shared/models';

@Component({
  selector: 'og-details-list',
  templateUrl: './details-list.component.html',
  styleUrls: ['./details-list.component.scss'],
  standalone: false
})
export class DetailsListComponent<T> {
  /** The title to use for the details card */
  @Input() title: string;
  /** The list of entries to display */
  @Input() list: T[];
  /** Defines if the list entries are being loaded */
  @Input() loading: boolean;
  /** Defines if the input template should be shown */
  @Input() showInputTemplate: boolean;
  /** Defines the custom theme to be used */
  @Input() theme: Theme = 'accent';
  /** Defines the custom size to be used */
  @Input() size: Size = 'medium';
  /** Defines if existing items can be deleted */
  @Input() canDeleteItems = true;
  /** Defines if new items can be added */
  @Input() canAddItems = true;
  /** Defines which item is selected */
  @Input() selectedIndex: number | undefined = undefined;
  /** The per-item template to use */
  @Input() itemTemplate?: TemplateRef<T>;
  /** Emits list changes on insertion and deletion */
  @Output() listChange = new EventEmitter<T[]>();
  /** Emits list item clicks */
  @Output() itemClick = new EventEmitter<number>();
  /** Emits add button clicks */
  @Output() addButtonClick = new EventEmitter<void>();

  showConfirmationOverlay = false;
  entryToDelete: T | undefined;

  triggerConfirmationOverlay(entryToDelete: T): void {
    this.showConfirmationOverlay = true;
    this.entryToDelete = entryToDelete;
  }

  confirmDeletion(): void {
    this.listChange.next(this.list.filter(listEntry => this.entryToDelete !== listEntry));
    this.showConfirmationOverlay = false;
    this.entryToDelete = undefined;
  }

  cancelDeletion(): void {
    this.showConfirmationOverlay = false;
    this.entryToDelete = undefined;
  }

  triggerNewEntryCreation(): void {
    this.addButtonClick.next();
  }

  constructConfirmationPanelText(): string {
    return `Confirm deletion of entry`;
  }
}
